export { SecurityToken } from './3.0.0';
